import { httpClient } from 'angieslist-app-platform';

const getAllHighlights = () => httpClient.get('/gateway/service-provider-profile/v1/service_provider/businessHighlights/all');
const updateBusinessHighlights = (serviceProviderId, values) =>
  httpClient.put(`/gateway/service-provider-profile/v1/service_provider/${serviceProviderId}/businessHighlights`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
    body: {
      businessHighlights: values,
    },
  });

export default { getAllHighlights, updateBusinessHighlights };



// WEBPACK FOOTER //
// ./src/modules/home/common/homeServices.js